import { render, staticRenderFns } from "./MFormMpsNumber.vue?vue&type=template&id=63cd1138"
import script from "./MFormMpsNumber.vue?vue&type=script&lang=js"
export * from "./MFormMpsNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports